import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Updates from './components/Updates';
import Media from './components/Media';
import Comments from './components/Comments';
import About from './components/About';
import IndexSection from './components/IndexSection';
import FAQ from './components/FAQ';
import Carousel from './components/Carousel';
import Cards from './components/Cards';
import Contact from './components/Contact';
import Topics from './components/Topics';
import Ranking from './components/Ranking';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Header scrolled={scrolled} />
      <main>
        <Hero />
        <Features />
        <Updates />
        <Media />
        <Comments />
        <About />
        <IndexSection />
        <FAQ />
        <Carousel />
        <Cards />
        <Contact />
        <Topics />
        <Ranking />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}